// import React from 'react';
// import { Form, Button, ListGroup } from 'react-bootstrap';

// const CouponForm = ({ coupon, setCoupon, applyCoupon, availableCoupons }) => {
//   return (
//     <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
//       {/* Fixed Apply Form */}
//       <div style={{ paddingBottom: '1rem', borderBottom: '1px solid #ddd' }}>
//         <Form className="d-flex">
//           <Form.Control
//             type="text"
//             placeholder="Enter coupon code"
//             value={coupon}
//             onChange={(e) => setCoupon(e.target.value)}
//             style={{ width: '100%', borderRadius: '20px' }}
//           />
//           <Button className="ms-2 checkout-btn" onClick={applyCoupon}>
//             Apply
//           </Button>
//         </Form>
//       </div>

//       {/* Scrollable Coupon List */}
//       <div
//         style={{
//           flex: 1,
//           overflowY: 'auto',
//           marginTop: '1rem',
//           paddingRight: '4px'
//         }}
//       >
//         <h6>Available Coupons:</h6>
//         <ListGroup>
//           {availableCoupons.map((code, idx) => (
//             <ListGroup.Item
//               key={idx}
//               action
//               onClick={() => setCoupon(code)}
//             >
//               {code}
//             </ListGroup.Item>
//           ))}
//         </ListGroup>
//       </div>
//     </div>
//   );
// };

// export default CouponForm;

import React from 'react';
import { Form, Button, ListGroup } from 'react-bootstrap';


const CouponForm = ({ coupon, setCoupon, applyCoupon, availableCoupons }) => {
  
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Fixed Apply Form */}
      <div style={{ paddingBottom: '1rem', borderBottom: '1px solid #ddd' }}>
        <Form
          className="d-flex"
          onSubmit={(e) => {
            e.preventDefault();
            applyCoupon();
          }}
        >
          <Form.Control
            type="text"
            placeholder="Enter coupon code"
            value={coupon}
            onChange={(e) => setCoupon(e.target.value)}
            style={{ width: '100%', borderRadius: '20px' }}
          />
          <Button className="ms-2 checkout-btn" type="submit">
            Apply
          </Button>
        </Form>
      </div>

      {/* Scrollable Coupon List */}
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          marginTop: '1rem',
          paddingRight: '4px',
        }}
      >
        <h6>Available Coupons:</h6>
        <ListGroup>
  {availableCoupons.map((couponObj, idx) => (
    <ListGroup.Item
      key={couponObj.id || idx}
      action
      onClick={() => setCoupon(couponObj.code)}
      className="mb-2"
      style={{
        borderRadius: '12px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
        padding: '12px 16px',
        transition: 'all 0.2s ease-in-out'
      }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <strong style={{ fontSize: '1.1rem', color: '#0c609c' }}>
            {couponObj.code}
          </strong>
          <div style={{ fontSize: '0.9rem', color: '#666' }}>
            {couponObj.description}
          </div>
        </div>
        <div className="text-end">
          <span
            className="badge bg-success"
            style={{ fontSize: '0.8rem', padding: '6px 10px', borderRadius: '20px' }}
          >
            {couponObj.discountType === 'percentage'
              ? `${couponObj.discountValue}% OFF`
              : `₹${couponObj.discountValue} OFF`}
          </span>
        </div>
      </div>
    </ListGroup.Item>
  ))}
</ListGroup>

      </div>
    </div>
  );
};

export default CouponForm;
